<script>
import Vue from 'vue';
import i18n from '@/plugins/i18n.js';
import ddoClientListTreeview from '@/components/ddoClientListTreeview.vue';

export default {
   name: "ddoClientListTreeviewLDAP",
   mixins: [ddoClientListTreeview],
   components: {
   },
   props: {
   },
   data: () => {
      return {
         rows: [ { _pk:0, name: "<root>", code: "", children: [] } ],
         errors: [],
         _openedChildRows: [],
         parentToggledRow: {}
      }
   },

   created() {
   },

   async mounted() {
      if ( this.parentToggledRow ) {
         this.adapt_ldap_informations(this.parentToggledRow);
         this.rows = [ { _pk:0, name: i18n.t('texts.lde_root'), code: null, file: "mdi-folder", is_root: true, is_ou: false, is_group:false, is_user:false, is_contact:false, code: this.parentToggledRow.xxx_dyn_ldap_basedn_fqdn+this.parentToggledRow.xxx_ad_org_unit, children: [] } ];
      }
   },

   methods: {

      adapt_ldap_informations(row) {
         if ( !row.plf_is_dynamic && row.plf_ws_url_base!=null ) {
            row.xxx_dyn_ldap_uri = row.plf_ws_url_base;
            row.xxx_dyn_ldap_basedn = row.plf_domain_radix;
         }
      },

      affect_row(currentrow,row) {
         let properties = row.lde_properties;
         currentrow._pk = row._pk;
         currentrow.name = row.lde_entry;
         currentrow.code = row.lde_code;
         currentrow.path = row.lde_path;
         currentrow.type = row.ldt_name;
         currentrow.is_ou = row.ldt_is_ou;
         currentrow.is_group = row.ldt_is_group;
         currentrow.is_user = row.ldt_is_user;
         currentrow.is_contact = row.ldt_is_contact;
         if ( properties!=null ) {
            currentrow.givenname = properties.givenname;
            currentrow.distinguishedname = properties.distinguishedname;
            currentrow.sn = properties.sn;
            currentrow.cn = properties.cn;
            currentrow.mail = properties.mail;
            currentrow.displayname = properties.displayname;
            currentrow.userprincipalname = properties.userprincipalname;
            currentrow.useraccountcontrol = properties.useraccountcontrol;
            currentrow.samaccountname = properties.samaccountname;
            currentrow.memberof = properties.memberof;
         }
         if ( currentrow.is_ou==true ) {
            currentrow.children = [];
         } 
      },

      set_one_row(row,parentId=null) {
         var item = {};
         this.affect_row(item,row);
         item.parent=parentId;
         return item;
      },

      update_current_row(row) {
         if ( this.currentItem ) {
            this.affect_row(this.currentItem,row);
         }
      },

      delete_current_row(row) {
         var _parentId = row.parent;
         var _parent = this.find_item_by_key(_parentId,this.rows);
         if ( _parent!=null ) {
            this.$api._remove_by_pk(_parent.children,row._pk);
         }
      },

      async refresh_rows(item) {
         //console.log('ddoClientListTreeviewLDAP.refresh_rows, item='+JSON.stringify(item));
         if ( typeof this.callbacks.refresh_rows == 'function' ) {
            var { errorinfos, api_response } = await this.callbacks.refresh_rows(item);
         } else {
            this.$emit('loading',true);
            var { errorinfos, api_response } = await this.$api.getRows(this.$router,this.level.api_code);
            this.$emit('loading',false);
         }
         this.errors = [ errorinfos ];
         var items = [];
         if ( api_response.error==0 && api_response.rows ) {
               for( var i=0;i<api_response.rows.length;i++) {
                  items[i] = this.set_one_row(api_response.rows[i],item._pk);
               }
         }
         item.children = items;
      },

   },

}
</script>